import { AxiosResponse } from 'axios';
import { all, AllEffect, call, CallEffect, ForkEffect, put, PutEffect, takeLeading } from 'redux-saga/effects';
import { fetchCartStatus } from 'b2b-apps/shop/cart/redux/cartStatus/actionCreators';
import { CollectedOrder } from 'b2b-apps/shop/collectedOrder/api/CollectedOrder';
import {
  clearCollectedOrder,
  placeCollectedOrderFulfilled,
  placeCollectedOrderRejected,
} from 'b2b-apps/shop/collectedOrder/redux/actionCreators';
import { PLACE_COLLECTED_ORDER } from 'b2b-apps/shop/collectedOrder/redux/actionTypes';
import { PlaceCollectedOrderAction } from 'b2b-apps/shop/collectedOrder/redux/types';
import { requestApiSaga } from 'b2b-apps/shop/common/redux/api/sagas';
import { reportError } from 'b2b-apps/shop/common/redux/errors/actionCreators';
import { parseError } from 'b2b-apps/shop/common/utils/api/error';
import { ROUTES } from 'b2b-apps/shop/routes/components/Router';
import { pushToRoute } from 'b2b-apps/shop/routes/redux/utils';

function* placeCollectedOrderSaga(action: PlaceCollectedOrderAction): Generator<
  CallEffect | PutEffect | Generator,
  void,
  AxiosResponse
> {
  const { data } = action.payload;

  try {
    const response = yield call(requestApiSaga, CollectedOrder.place(data));

    yield put(placeCollectedOrderFulfilled(response.data));
    yield put(fetchCartStatus());
    yield put(clearCollectedOrder());
  } catch (error) {
    yield put(placeCollectedOrderRejected(parseError(error)));
    yield put(reportError(action.type, error));
  }

  yield pushToRoute(ROUTES.collectedOrderConfirmation);
}

function* collectedOrderSaga(): Generator<AllEffect<ForkEffect>, void> {
  yield all([takeLeading(PLACE_COLLECTED_ORDER, placeCollectedOrderSaga)]);
}

export { collectedOrderSaga };
